import flow from 'lodash/flow';

const getUserState = ({ user }) => user;
const getUserInfo = ({ userInfo }) => userInfo;
export const getUser = flow(getUserState, getUserInfo);
